<template>
  <div>
    <SFTPFilesHeader />
    <div class="sftp-files">
      <SFTPFilesCollapse card name="PMC" creationDate="2022-03-19">
        <template slot="inner">
          <SFTPFilesCollapse name="CDRS" creationDate="2022-03-19">
            <template slot="inner">
              <SFTPFilesFile name="CDRS-1.txt" creationDate="2022-03-19" />
              <SFTPFilesFile name="CDRS-2.txt" creationDate="2022-03-19" />
              <SFTPFilesCollapse name="Errors" creationDate="2022-03-19">
                <template slot="inner">
                  <SFTPFilesFile
                    name="CDRS-Error-1.txt"
                    creationDate="2022-03-19"
                  />
                  <SFTPFilesFile
                    name="CDRS-Error-2.txt"
                    creationDate="2022-03-19"
                  />
                </template>
              </SFTPFilesCollapse>
            </template>
          </SFTPFilesCollapse>
          <SFTPFilesCollapse name="Sessions" creationDate="2022-03-19">
            <template slot="inner">
              <SFTPFilesFile name="Sessions-1.txt" creationDate="2022-03-19" />
              <SFTPFilesFile name="Sessions-2.txt" creationDate="2022-03-19" />
            </template>
          </SFTPFilesCollapse>
        </template>
      </SFTPFilesCollapse>
      <SFTPFilesCollapse card name="PMC" creationDate="2022-03-19">
        <template slot="inner">
          <SFTPFilesCollapse name="CDRS" creationDate="2022-03-19">
            <template slot="inner">
              <SFTPFilesFile name="CDRS-1.txt" creationDate="2022-03-19" />
              <SFTPFilesFile name="CDRS-2.txt" creationDate="2022-03-19" />
              <SFTPFilesCollapse name="Errors" creationDate="2022-03-19">
                <template slot="inner">
                  <SFTPFilesFile
                    name="CDRS-Error-1.txt"
                    creationDate="2022-03-19"
                  />
                  <SFTPFilesFile
                    name="CDRS-Error-2.txt"
                    creationDate="2022-03-19"
                  />
                </template>
              </SFTPFilesCollapse>
            </template>
          </SFTPFilesCollapse>
          <SFTPFilesCollapse name="Sessions" creationDate="2022-03-19">
            <template slot="inner">
              <SFTPFilesFile name="Sessions-1.txt" creationDate="2022-03-19" />
              <SFTPFilesFile name="Sessions-2.txt" creationDate="2022-03-19" />
            </template>
          </SFTPFilesCollapse>
        </template>
      </SFTPFilesCollapse>
      <SFTPFilesCollapse card name="PMC" creationDate="2022-03-19">
        <template slot="inner">
          <SFTPFilesCollapse name="CDRS" creationDate="2022-03-19">
            <template slot="inner">
              <SFTPFilesFile name="CDRS-1.txt" creationDate="2022-03-19" />
              <SFTPFilesFile name="CDRS-2.txt" creationDate="2022-03-19" />
              <SFTPFilesCollapse name="Errors" creationDate="2022-03-19">
                <template slot="inner">
                  <SFTPFilesFile
                    name="CDRS-Error-1.txt"
                    creationDate="2022-03-19"
                  />
                  <SFTPFilesFile
                    name="CDRS-Error-2.txt"
                    creationDate="2022-03-19"
                  />
                </template>
              </SFTPFilesCollapse>
            </template>
          </SFTPFilesCollapse>
          <SFTPFilesCollapse name="Sessions" creationDate="2022-03-19">
            <template slot="inner">
              <SFTPFilesFile name="Sessions-1.txt" creationDate="2022-03-19" />
              <SFTPFilesFile name="Sessions-2.txt" creationDate="2022-03-19" />
            </template>
          </SFTPFilesCollapse>
        </template>
      </SFTPFilesCollapse>
    </div>
  </div>
</template>
<script>
import SFTPFilesCollapse from '@/components/ui/SFTPFilesCollapse';
import SFTPFilesFile from '@/components/ui/SFTPFilesFile';
import SFTPFilesHeader from '@/components/ui/SFTPFilesHeader';

export default {
  name: 'SFTPFiles',
  components: {
    SFTPFilesCollapse,
    SFTPFilesFile,
    SFTPFilesHeader,
  },
  data() {
    return {
      page: 1,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);
      // await this.$store.dispatch('storeCDRs', { query: {}, page: this.page });
      this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.sftp-files {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
</style>
